import z from "zod/v4";
import { safeParseInt, safeParseFloat } from "./safe-parse-number";

export const zTimeHHmm = () =>
  z.iso.time({
    precision: -1,
    error: "Must be in HH:mm format",
  });

export type FormSchemaType = "storage" | "validation";

export type FormSchema<T> = (type: FormSchemaType) => z.ZodType<T, T>;

export const zFormFloat = (type: FormSchemaType) => {
  if (type === "storage") {
    return z.string();
  }
  return z.string().refine((val) => safeParseFloat(val) !== null, {
    error: "Must be a number",
  });
};

// TODO: Show "integer" instead of "number" only if the user enters an otherwise valid float.
export const zFormInt = (type: FormSchemaType) => {
  if (type === "storage") {
    return z.string();
  }
  return z.string().refine((val) => safeParseInt(val) !== null, {
    error: "Must be an integer",
  });
};

export const zFormFloatNullable = (type: FormSchemaType) => {
  if (type === "storage") {
    return z.string();
  }
  return z.string().refine((val) => val === "" || safeParseFloat(val) !== null, {
    error: "Must be a number",
  });
};

export const zFormIntNullable = (type: FormSchemaType) => {
  if (type === "storage") {
    return z.string();
  }
  return z.string().refine((val) => val === "" || safeParseInt(val) !== null, {
    error: "Must be an integer",
  });
};

export const zFormTime = (type: FormSchemaType) => {
  if (type === "storage") {
    return z.string();
  }
  return zTimeHHmm();
};

export const zTimezone = () =>
  z.string().refine(
    (tz) => {
      try {
        Temporal.PlainDate.from("2000-01-01").toZonedDateTime(tz);
        return true;
      } catch {
        return false;
      }
    },
    { message: "Invalid timezone" },
  );
